// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3rpX-","resendInfoText":"OnGoingPaymentBox_resendInfoText__2kh_m"};